module.exports = __webpack_public_path__ + "img/img7.b25e5af4.png";